import { Box, Container, Grid, Typography, useTheme } from "@mui/material";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function PageHeader(props) {
  const { title, subTitle, subTitle2, headerImage, right } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        color: "#fff",
        width: "100%",
        maxWidth: "100%",
        minHeight: ["150px", "250px"],
        display: "flex",
        alignItems: "center",
        boxShadow: "inset 0 0 0 1000px rgb(0 0 0 / 50%)",
        objectFit: "contain",
        background: `url(${
          headerImage?.url ||
          `${getEnvironmentVariable(
            "SYSTEM_IMAGES_CLOUDFRONT"
          )}/images/EventImage${
            theme?.palette?.mode === "dark" ? "Dark" : ""
          }.png`
        })`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <Box width="100%">
        <Container maxWidth="lg">
          <Grid container gap={2} sx={{ p: 2 }} alignItems="center">
            <Grid item xs={12} md={right ? 6 : 12}>
              <Typography
                variant="h2"
                gutterBottom
                sx={{
                  color: "#fff",
                }}
              >
                {title}
              </Typography>
              {subTitle && (
                <Typography
                  variant="h3"
                  gutterBottom
                  sx={{
                    color: "#fff",
                  }}
                >
                  {subTitle}
                </Typography>
              )}
              {subTitle2 && (
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    color: "#fff",
                  }}
                >
                  {subTitle2}
                </Typography>
              )}
            </Grid>
            {right && (
              <Grid
                item
                xs={12}
                md={6}
                sx={{ textAlign: ["left", "left", "right"] }}
              >
                {right}
              </Grid>
            )}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
